import { z } from 'zod';
import { minorUnitsFromAmount } from '@shared/components/form/config-value';
import { formatMinor } from '../utils/topUpAmount';

export const topUpSchema = (minimumMinor: number) =>
    z.object({
        amountGross: z
            .string()
            .trim()
            .refine((value) => /^\d+(\.\d{1,2})?$/.test(value), 'Enter an amount in pounds and pence')
            .refine(
                (value) => (minorUnitsFromAmount(value) ?? 0) >= minimumMinor,
                `Amount paid must be at least £${formatMinor(minimumMinor)}`,
            ),
        paymentReference: z
            .string()
            .trim()
            .min(1, 'Enter the payment reference')
            .max(100, 'Payment reference must be 100 characters or fewer'),
    });

export type TopUpValues = z.infer<ReturnType<typeof topUpSchema>>;
